<script>
import Apps from '@/core/Apps';

export default {
    props: {
        appName: {
            type: String,
            required: true
        },
    },

    computed: {
        isSecureAuthenticationEnabled() {
            return this.$root.inDevelopmentMode || this.$store.state.auth.user.is_secure_authentication_enabled || this.$store.state.brand !== 'terapeut_booking';
        },

        nudgeText() {
            let user = this.$store.state.auth.user;
            let isOwner = this.$store.getters['auth/isOwner'];
            let bankIDActive = this.$store.getters['apps/isAppEnabled'](Apps.BankID);

            if (user.country === 'da') {
                return trans('apps.danish_secure_authentication_nudge');
            } else if (user.country === 'no' && bankIDActive && isOwner) {
                return trans('apps.bankid_disable_email_login_nudge_owner');
            } else if (user.country === 'no' && bankIDActive) {
                return trans('apps.bankid_disable_email_login_nudge_non_owner');
            } else if (user.country === 'no') {
                return trans('apps.norwegian_secure_authentication_nudge');
            }

            return trans('apps.international_secure_authentication_nudge');
        },
    },
}
</script>

<template>
    <div v-if="!isSecureAuthenticationEnabled" class="text-center container mx-auto">
        <i class="fa-duotone fa-lock-keyhole text-primary text-4xl"></i>
        <h4>{{ trans('apps.app_locked', { appName }) }}</h4>
        <h5 v-sanitize-html="nudgeText"></h5>
    </div>

    <div v-else>
        <slot></slot>
    </div>
</template>
